export default __webpack_public_path__ + "static/media/thumb-point.a3fa6a02.svg";